export const isFullStatic = false
export const staticPath = "/bravado/frontend/.nuxt/static-json"
export const publicPath = "https://static-prod.bravado.co/nuxt/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"